import { render, staticRenderFns } from "./AttentionEffect.vue?vue&type=template&id=44576222&scoped=true&"
import script from "./AttentionEffect.vue?vue&type=script&lang=js&"
export * from "./AttentionEffect.vue?vue&type=script&lang=js&"
import style0 from "./AttentionEffect.vue?vue&type=style&index=0&id=44576222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44576222",
  null
  
)

export default component.exports